export const Portals = {
  HeaderFilters: 'header-filters',
  DedicatedHeader: 'dedicated-header',
  DedicatedHeaderTabs: 'dedicated-header-tabs',
  DedicatedButton: 'dedicated-button',
  DedicatedActionButtonGroup: 'dedicated-action-button-group',
  DedicatedDropdown: 'dedicated-dropdown',
}
